import { render } from "./IconFacebookPage.vue?vue&type=template&id=91a572b8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFacebookPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91a572b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91a572b8', __exports__)) {
    api.reload('91a572b8', __exports__)
  }
  
  module.hot.accept("./IconFacebookPage.vue?vue&type=template&id=91a572b8", () => {
    api.rerender('91a572b8', render)
  })

}


export default __exports__